import { Component } from '@angular/core';

@Component({
  selector: 'app-social-media-link',
  templateUrl: './social-media-link.component.html',
  styleUrls: ['./social-media-link.component.scss'],
  standalone: true,
})
export class SocialMediaLinkComponent {}
